<template>
  <b-modal
    v-model="localIsCreateModal"
    centered
    hide-footer
    title="Add Social Learning"
    size="lg"
  >
    <form @submit.prevent="submit">
      <div class="form-group">
        <div class="row">
          <div class="col-6 mt-3">
            <label>Category <span class="text-danger">*</span></label>
            <v-select
              v-model="form.category"
              :options="category"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Category"
            />
          </div>

          <div class="col-6 mt-3">
            <label>Title <span class="text-danger">*</span></label>
            <input
              type="text"
              v-model="form.title"
              class="form-control"
              placeholder="Coaching Title"
            />
          </div>

          <div class="col-6 mt-3">
            <label>Coach / Mentor <span class="text-danger">*</span></label>
            <v-select
              v-model="form.nik"
              :options="coaches"
              label="employee_name"
              :reduce="(c) => c.employee_nik"
              placeholder="Search By Name"
            />
          </div>

          <div class="col-6 mt-3">
            <label
              >Methodology Description <span class="text-danger">*</span></label
            >
            <input
              type="text"
              v-model="form.methodology"
              class="form-control"
              placeholder="Coaching Methodology"
            />
          </div>

          <div class="col-6 mt-3">
            <label>Related Competency <span class="text-danger">*</span></label>
            <v-select
              multiple
              v-model="form.competency"
              :options="competencyData"
              label="name"
              :reduce="(e) => e.id"
              placeholder="Select Related Competency"
            />
          </div>

          <div class="col-6 mt-3">
            <label
              >Social Learning Cover <span class="text-danger">*</span></label
            >
            <div class="col-12 px-0">
              <input
                type="file"
                ref="coverFile"
                class="form-control"
                accept="image/*"
                @change="handleFileUpload"
              />
              <small class="text-muted">
                Supported formats: JPG, PNG, GIF (Max: 2MB)
              </small>
            </div>
            <div class="col-12 px-0 mt-2">
              <div v-if="coverPreview" class="cover-preview">
                <img
                  :src="coverPreview"
                  alt="Cover Preview"
                  class="img-fluid rounded"
                  style="max-height: 150px; object-fit: cover; width: 100%"
                />
                <button
                  type="button"
                  class="btn btn-sm btn-danger mt-2"
                  @click="removeCover"
                >
                  <i class="fas fa-trash me-1"></i>
                  Remove Cover
                </button>
              </div>
              <div v-else class="cover-placeholder">
                <div
                  class="d-flex align-items-center justify-content-center bg-light rounded"
                  style="height: 150px; border: 2px dashed #dee2e6"
                >
                  <div class="text-center text-muted">
                    <i class="fas fa-image fa-2x mb-2"></i>
                    <p class="mb-0">No cover selected</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="form-group">
        <button
          style="float: right"
          class="mt-4 btn btn-primary"
          type="submit"
          :disabled="isSaving"
        >
          <span v-if="!isSaving">
            {{ form.cover ? "Submit with Cover" : "Submit" }}
          </span>
          <span v-else>
            <span class="spinner-border spinner-border-sm" role="status" />
            {{ form.cover ? "Uploading with Cover..." : "Mengirim..." }}
          </span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "AddCoaching",
  props: {
    isCreateModal: Boolean,
    modelValue: Boolean,
    coaches: Array,
    competencyData: Array,
    category: Array,
    isSaving: Boolean,
  },
  data() {
    return {
      form: {
        title: "",
        nik: "",
        methodology: "",
        competency: [],
        category: "",
        cover: null,
      },
      coverPreview: null,
      maxFileSize: 2 * 1024 * 1024, // 2MB in bytes
    };
  },
  computed: {
    localIsCreateModal: {
      get() {
        return this.isCreateModal;
      },
      set(value) {
        this.$emit("update:isCreateModal", value);
        if (!value) {
          this.resetForm();
        }
      },
    },
  },
  watch: {
    isCreateModal(newVal) {
      if (!newVal) {
        this.resetForm();
      }
    },
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      // Validate file type
      if (!file.type.startsWith("image/")) {
        this.$swal(
          "Tipe File Tidak Valid",
          "Pilih file gambar yang valid",
          "error"
        );
        this.resetFileInput();
        return;
      }

      // Validate file size
      if (file.size > this.maxFileSize) {
        this.$swal(
          "File Terlalu Besar",
          "Ukuran file harus kurang dari 2MB",
          "error"
        );
        this.resetFileInput();
        return;
      }

      this.form.cover = file;

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        this.coverPreview = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeCover() {
      this.form.cover = null;
      this.coverPreview = null;
      this.resetFileInput();
    },

    resetFileInput() {
      if (this.$refs.coverFile) {
        this.$refs.coverFile.value = "";
      }
    },

    submit() {
      // Validate required fields including cover
      if (
        !this.form.category ||
        !this.form.title ||
        !this.form.nik ||
        !this.form.methodology ||
        !this.form.competency.length ||
        !this.form.cover
      ) {
        this.$swal(
          "Validasi Gagal",
          "Lengkapi semua kolom wajib, termasuk gambar cover",
          "error"
        );
        return;
      }

      // Show different loading text if cover is being uploaded
      if (this.form.cover) {
        console.log("Submitting form with cover image:", this.form.cover.name);
      }
      this.$emit("save", this.form);
    },

    resetForm() {
      this.form = {
        title: "",
        nik: "",
        methodology: "",
        competency: [],
        category: "",
        cover: null,
      };
      this.coverPreview = null;
      this.resetFileInput();
    },
  },
};
</script>

<style scoped>
.cover-preview {
  position: relative;
}

.cover-preview img {
  border: 2px solid #dee2e6;
  transition: all 0.3s ease;
}

.cover-preview img:hover {
  transform: scale(1.02);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.cover-placeholder {
  transition: all 0.3s ease;
}

.cover-placeholder:hover {
  background-color: #f8f9fa !important;
}

.form-control:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn-danger {
  transition: all 0.2s ease;
}

.btn-danger:hover {
  transform: translateY(-1px);
}
</style>
